module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0074.jpg?v=f4df226c";